import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createProject } from '../../store/actions/projectActions'
import { Redirect } from 'react-router-dom'
import "./Questionbox.css"
import {
    Container,
    Form,
    Button,
    NavLink,
    NavbarBrand
  } from 'reactstrap';

class CreateProject extends Component {
    state = {
        title: '',
        content: ''
    }
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    handleSubmit = (e) => {
        e.preventDefault();
        // console.log(this.state);
        this.props.createProject(this.state)
        this.props.history.push('/');
    }
    render() {
        const { auth } = this.props;
        if (!auth.uid) return <Redirect to='/signin' />

        return (
            <div>
                {/* <NewNav/> */}
                 <div className="container comming">
                
                <form onSubmit={this.handleSubmit} className="boxQues">
                    <h5 className="questions">Question box (กล่องคำถาม)</h5>
                    <div className="input-field">
                        <label htmlFor="title">Title</label>
                        <input type="text" id="title" onChange={this.handleChange} />
                    </div>
                    <div className="input-field">
                        <label htmlFor="content">Content</label>
                        <textarea id="content" className="materialize-textarea" onChange={this.handleChange}></textarea>
                    </div>
                    <div className="input-field">
                        <button className="btn orange lighten-1 z-depth-0">Submit</button>
                    </div>
                </form>
                
            </div>
            <div className="footer text-footer">
                <p>Surasak   Noorurk</p>
                <p> Project 5935512072 Computer Engineering</p> 
                <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>         
            </div>
           
            </div> 
        )
    }
}

const mapStateToProps = (state) => {
    console.log(state);
    return {
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createProject: (project) => dispatch(createProject(project))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProject)